import React from "react"

import { SimpleExecutorRecord } from "src/services/api/document"
import CustomAutocomplete from "../../components/CustomAutocomplete"
import { useResponsive } from "src/utils/useResponsive"

interface Props {
    selected: SimpleExecutorRecord,
    label: string,
    onChanged: (val: SimpleExecutorRecord) => void,
    executorList: SimpleExecutorRecord[]
}

const ExecutorSelect: React.FC<Props> = ({ label, selected, onChanged, executorList }: Props) => {
  const { isMobile } = useResponsive()
  const descriptiveName = (executor: SimpleExecutorRecord) => {
    return `${executor.firstName} ${executor.lastName} (${executor.userName})`
  }

  return (<>
    {executorList.length > 0 && <CustomAutocomplete
      value={selected}
      options={executorList}
      getOptionLabel={(option) => descriptiveName(option)}
      onChange={(e, val) => val && onChanged(val as SimpleExecutorRecord)}
      label={label}
      isOptionEqualToValue={(o, v) => o.id === v.id}
      disableClearable
      disabled={isMobile}
    />}
  </>
  )
}
export default ExecutorSelect